import { toast, ToastPosition } from "react-toastify";

const TOAST_POSITION: ToastPosition = "top-right";

export default class ToastService {
    showSuccess(message: string) {
        toast.success(message, {
            position: TOAST_POSITION,
            className: "toast-message",
        });
    }

    showError(message: string) {
        toast.error(message, {
            position: TOAST_POSITION,
            className: "toast-message",
        });
    }

    showWarning(message: string) {
        toast.warning(message, {
            position: TOAST_POSITION,
            className: "toast-message",
        });
    }

    showInfo(message: string) {
        toast.info(message, {
            position: TOAST_POSITION,
            className: "toast-message",
        });
    }
}
